var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social icon",
    clipPath: "url(#clip0_4040_61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.266 12.8978C24.266 12.082 24.1999 11.2619 24.0588 10.4594H12.74V15.0804H19.2217C18.9528 16.5707 18.0885 17.8891 16.823 18.7269V21.7253H20.69C22.9608 19.6352 24.266 16.5487 24.266 12.8978Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.74 24.6222C15.9764 24.6222 18.7058 23.5595 20.6944 21.7252L16.8274 18.7269C15.7516 19.4588 14.3626 19.8733 12.7444 19.8733C9.61376 19.8733 6.95934 17.7612 6.00693 14.9216H2.01648V18.0126C4.05359 22.0647 8.20278 24.6222 12.74 24.6222Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.00253 14.9216C5.49987 13.4313 5.49987 11.8174 6.00253 10.3271V7.23615H2.01649C0.31449 10.6269 0.31449 14.6218 2.01649 18.0126L6.00253 14.9216Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.74 5.371C14.4508 5.34454 16.1043 5.9883 17.3433 7.17001L20.7694 3.74395C18.6 1.70684 15.7207 0.586872 12.74 0.622147C8.20277 0.622147 4.05359 3.17956 2.01648 7.23615L6.00252 10.3271C6.95052 7.48307 9.60935 5.371 12.74 5.371Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4040_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.621338)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialicon);
export default __webpack_public_path__ + "static/media/Social icon.37adc7cfaa4e591de73abb7debea6577.svg";
export { ForwardRef as ReactComponent };